import './Cardlevel.css'
import React, { useState, useEffect } from 'react';
import './../App.css';
import fuelGnIcon from '../img/level-menu-icon-sm-gr.svg'
import fuelGyIcon from '../img/level-menu-icon-sm-gy.svg'
import fuelOrIcon from '../img/level-menu-icon-sm-or.svg'
import fuelRdIcon from '../img/level-menu-icon-sm-rd.svg'
import coolGnIcon from '../img/icon-water-gr.svg'
import coolGyIcon from '../img/icon-water-gy.svg'
import coolOrIcon from '../img/icon-water-or.svg'
import coolRdIcon from '../img/icon-water-rd.svg'
import hidGnIcon from '../img/icon-hid-gr.svg'
import hidGyIcon from '../img/icon-hid-gy.svg'
import hidOrIcon from '../img/icon-hid-or.svg'
import hidRdIcon from '../img/icon-hid-rd.svg'
import dotGnIcon from '../img/dot-green-icon.svg'
import dotGyIcon from '../img/dot-grey-icon.svg'
import warning_gy_icon from '../img/warning-sm-gy-icon.svg'
import info_icon from '../img/info-sm-gy-icon.svg'
import tooltip_or_label from '../img/tooltip-or-label.svg'


function Cardlevel(props){

    const open = url => window.open(url)
    const coolLimit1 = 75
    const coolLimit2 = 25

    const fuelLimit1 = 40
    const fuelLimit2 = 30

    const hidLimit1 = 40
    const hidLimit2 = 30

    let cool1=coolGyIcon;
    props.cool1>coolLimit1?cool1=coolGnIcon:props.cool1<=coolLimit1&&props.cool1>coolLimit2?cool1=coolOrIcon:props.cool1<=coolLimit1&&props.cool1<=coolLimit2&&(cool1=coolRdIcon);
    let cool2=coolGyIcon;
    props.cool2>coolLimit1?cool2=coolGnIcon:props.cool2<=coolLimit1&&props.cool2>coolLimit2?cool2=coolOrIcon:props.cool2<=coolLimit1&&props.cool2<=coolLimit2&&(cool2=coolRdIcon);
    let hid=hidGyIcon;
    props.hid>hidLimit1?hid=hidGnIcon:props.hid<=hidLimit1&&props.hid>hidLimit2?hid=hidOrIcon:props.hid<=hidLimit1&&props.hid<=hidLimit2&&(hid=hidRdIcon);
    let fuel=fuelGyIcon;
    props.fuel>fuelLimit1?fuel=fuelGnIcon:props.fuel<=fuelLimit1&&props.fuel>fuelLimit2?fuel=fuelOrIcon:props.fuel<=fuelLimit1&&props.fuel<=fuelLimit2&&(fuel=fuelRdIcon);



    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
        setVisible(true);
        }, props.index * 0.25); // Ajusta el tiempo de retraso según sea necesario
        return () => clearTimeout(timer);
    }, [props.index]);



    let color1= '#abfdae'
    let color2= '#484848'

  
    // Combinación de estilos existentes con filter: opacity(1) y border condicional
    const combinedStyles = {
      color: props.online === "online" ? color1 : color2,
      filter: 'opacity(1)',
      border: props.pm === "true" ? "3px solid gray" : "",
      animationDelay: `${props.index * 0.025}s`,
    };

    const id = props.tkd.replace("TKD","")

    var url = "../nivel/?tkd="+id
    
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') { // dev code
        url = "http://isight.cl/nivel/?tkd="+id 
    }


    const pm = {
        fontSize:'10px',
        color: 'tomato',
        paddingLeft: "10px"
      }
 
    return(
   
        <div className={`card ${visible ? 'fade-in' : ''}`} style={combinedStyles} onClick={()=> open(url)}>



                <div className="tkd" style={props.online==="online"?{color:color1}:{color:color2}}>TKD</div>
                <div className="serie">{props.firm}</div>
                <div className="number" style={props.online==="online"?{color:color1}:{color:color2}} >{props.tkd.replace("TKD","")}
                </div>

                {/* -----------  FUEL INDICATOR ----------------------*/}

                {/*<div className="fuel-title">COMBUSTIBLE</div>--> */ }
                <div className="cardlevel-date" >{props.date}</div>
                <div className="autonomy">AUTONOMIA <span>hasta el 25%</span> {props.aut} hrs</div>
                <div className={props.fuel<fuelLimit2?'fuel blink':'fuel'}>
                    <img  src={fuel}/>
                    <span style={props.fuel>99?{fontSize:'14px'}:{}} >&nbsp;{props.fuel}</span>
                    <span style={{fontSize:"8px"}}>%</span>
                </div>

                {/* -----------  ONLINE indicator ----------------------*/}

                <div className="online" style={props.online==="online"?{color:color1}:{color:color2}} > 
                    <img src={props.online==="online"?dotGnIcon:dotGyIcon}/>&nbsp;{props.online.toUpperCase()}{props.pm ==="true"?<span style={pm}>&#11044;&nbsp;TRUCK_SHOP</span>:""}
                </div>

                {/* -----------  COOLANT indicator ----------------------*/}

                <div className="direccion">
                    <div className={props.cool1<coolLimit2?'coolant-1 tooltip blink':'coolant-1 tooltip'}>
                        <img src={cool1}/>
                        <span className="tooltiptext">{props.cool1}</span>
                    </div>
                    <div className={props.cool2<coolLimit2?'coolant-2 tooltip blink':'coolant-2 tooltip'}>
                        <img src={cool2}/>
                        <span className="tooltiptext">{props.cool2}</span>
                    </div>
                    <div className="acc-dir-txt ">COOLANT</div>
                </div>

                {/* -----------  HIDRAULIC indicator ----------------------*/}

                <div className="freno">
                    <div className={props.hid<hidLimit2?'hid-icon tooltip blink':'hid-icon tooltip'}>
                        <img src={hid}/>
                        <span className="tooltiptext">{props.hid}</span>
                    </div>
                    <div className="acc-fre-txt ">HIDRAULICO</div>
                </div>

                {/* -----------   INFO ICONS  ----------------------*/}

                <div className="info">
                    <div className="warning-icon">
                        <img src={warning_gy_icon}/>
                    </div>
                    <div className="info-icon">
                        <img src={info_icon}/>
                    </div>
                </div>
        </div>
            
)}

export default Cardlevel
